import {
	SHOULD_SHOW_KANBAN_ONBOARDING_MODAL,
	SHOULD_SHOW_WELCOME_ONBOARDING_MODAL,
} from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { sessionStorage } from '@atlassian/jira-onboarding-core/src/utils/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createStateHook, createActionsHook } from '@atlassian/react-sweet-state';
import { actions } from './actions/index.tsx';
import type { State } from './types.tsx';

export type Actions = typeof actions;

const isModalVisible = (key: string) => sessionStorage.get(key) !== undefined;

// If either modal is visible, then don't open the ICC
const setInitialState = () =>
	!(
		isModalVisible(SHOULD_SHOW_KANBAN_ONBOARDING_MODAL) ||
		isModalVisible(SHOULD_SHOW_WELCOME_ONBOARDING_MODAL)
	);

export const initialState: State = {
	get keepIccOpen() {
		return setInitialState();
	},
	hasCreatedIssueICC: true,
	triggerReason: 'emptyBoard',
	keepIccOpenOnListView: false,
};

const store = createStore<State, Actions>({
	name: 'jsw-onboarding-keep-icc-open',
	initialState,
	actions,
});

export const useKeepIccOpenState = createStateHook(store, {
	selector: (state) => state.keepIccOpen,
});
export const useKeepIccOpenStateOnListView = createStateHook(store, {
	selector: (state) => state.keepIccOpenOnListView,
});
export const useKeepIccOpenActions = createActionsHook(store);

export const useTriggerEventState = createStateHook(store, {
	selector: (state) => ({
		hasCreatedIssueICC: state.hasCreatedIssueICC,
		triggerReason: state.triggerReason,
	}),
});
